/* Luxe layer — motion helpers.
   - Header shadow once the page scrolls.
   - Image reveal for image-with-text / multicolumn media.
   - One-time stagger for product grids.
   Content is never hidden unless this script runs (html.luxe-js gate),
   and everything is skipped for prefers-reduced-motion. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onScroll() {
    if (window.scrollY > 8) root.classList.add('luxe-scrolled');
    else root.classList.remove('luxe-scrolled');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if (reduce || !('IntersectionObserver' in window)) return;

  // html.luxe-js is set early by snippets/luxe-head.liquid.
  if (!root.classList.contains('luxe-js')) return;

  function mark() {
    document
      .querySelectorAll('.image-with-text__media:not([data-luxe-reveal])')
      .forEach(function (el) { el.setAttribute('data-luxe-reveal', ''); });

    document
      .querySelectorAll(
        '.section-featured-collection .product-grid:not([data-luxe-stagger]),' +
        '.section-featured-collection .grid.product-grid:not([data-luxe-stagger]),' +
        '.related-products .product-grid:not([data-luxe-stagger]),' +
        '.multicolumn-list:not([data-luxe-stagger])'
      )
      .forEach(function (grid) {
        grid.setAttribute('data-luxe-stagger', '');
        Array.prototype.forEach.call(grid.children, function (child, i) {
          child.style.setProperty('--n', Math.min(i, 8));
        });
      });
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          // Clipped media are observed through their parent (clip-path hides them from the observer).
          var targets = el.hasAttribute('data-luxe-reveal-host') ? el.querySelectorAll('[data-luxe-reveal]') : [el];
          Array.prototype.forEach.call(targets, function (t) { t.classList.add('is-revealed'); });
          io.unobserve(el);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
  );

  function observe() {
    mark();
    document.querySelectorAll('[data-luxe-reveal]:not(.is-revealed)').forEach(function (el) {
      var host = el.parentElement;
      if (host && !host.hasAttribute('data-luxe-reveal-host')) {
        host.setAttribute('data-luxe-reveal-host', '');
        io.observe(host);
      }
    });
    document.querySelectorAll('[data-luxe-stagger]:not(.is-revealed)').forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();

  // Product recommendations load asynchronously.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; observe(); });
  }).observe(document.body, { childList: true, subtree: true });

  // Safety net: reveal anything still hidden after 4s (e.g. off-screen print, odd layouts).
  setTimeout(function () {
    document.querySelectorAll('[data-luxe-reveal], [data-luxe-stagger]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) el.classList.add('is-revealed');
    });
  }, 4000);
})();
